import styled from 'styled-components';

export const Wrapper = styled.div`
  overflow: auto;
  height: 100%;
`;
